export const serviceInstructionsMessages = {
  general: 'Hướng dẫn chung',
  detail: 'Chi tiết',
  profile: 'Hồ sơ',
  update: 'Cập nhật thông tin hướng dẫn'
};
